'use strict';

var internals = {};

module.exports = function (timeout) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
};